import { CompanyRepository } from "../../repositories/CompanyRepository";

/**
 * Get Companies Use Case
 * Fetches all companies with pagination
 */
export class GetCompaniesUseCase {
  constructor(private repository: CompanyRepository) {}

  async execute(page: number = 1, limit: number = 50, search?: string) {
    return await this.repository.getCompanies(page, limit, search);
  }
}

